import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import Loadable from 'react-loadable';
import { ReduxState } from '../redux/reducers/global';
import { selectUserType } from '../redux/selectors/auth';
import LoadingSpinner from '../utils/LoadingSpinner';
interface RoutingState {
	getFirebaseData: () => void;
	isAdmin: boolean;
	isProfessor: boolean;
}

const AdminRoutesLoadable = Loadable({
	loader: () => import('./routes/AdminRoutes'),
	loading() {
		return <LoadingSpinner type="clock" />;
	}
});

const MonitorRoutesLoadable = Loadable({
	loader: () => import('./routes/MonitorRoutes'),
	loading() {
		return <LoadingSpinner type="boxlader" />;
	}
});

const ColegioRoutesLoadable = Loadable({
	loader: () => import('./routes/ColegioRoutes'),
	loading() {
		return <LoadingSpinner type="rise-loader" />;
	}
});

const ProfesoresRoutesLoadable = Loadable({
	loader: () => import('./routes/ProfesoresRoutes'),
	loading() {
		return <LoadingSpinner type="hash" />;
	}
});

const EstudiantesRoutesLoadable = Loadable({
	loader: () => import('./routes/EstudianteRoutes'),
	loading() {
		return <LoadingSpinner type="hash" />;
	}
});

class Routing extends React.Component<any, RoutingState> {
	render() {
		const { isAdmin, location, isProfessor, isStudent, isColegio, isMonitor } = this.props;
		return (
			<Router>
				<React.Fragment>
					{isAdmin && <AdminRoutesLoadable />}
					{isProfessor && <ProfesoresRoutesLoadable />}
					{isStudent && <EstudiantesRoutesLoadable location={location} />}
					{isColegio && <ColegioRoutesLoadable location={location}></ColegioRoutesLoadable>}
					{isMonitor && <MonitorRoutesLoadable location={location} />}
				</React.Fragment>
			</Router>
		);
	}
}

const mapStateToProps = (state: ReduxState) => {
	const isAdmin = selectUserType(state) === 'admin';
	const isProfessor = selectUserType(state) === 'profesor';
	const isStudent = selectUserType(state) === 'student';
	const isColegio = selectUserType(state) === 'colegio';
	const isMonitor = selectUserType(state) === 'monitor';

	return {
		isAdmin,
		isProfessor,
		isStudent,
		isColegio,
		isMonitor
	};
};

export default connect(mapStateToProps)(Routing);
